import { useEffect, useRef } from "react";
import { registerRecentView } from "./recentViews";

const normalize = (value) => String(value ?? "").trim();

export default function useRegisterRecentView({
  itemType,
  itemId,
  title,
  secondaryText = null,
  route = null,
  enabled = true,
}) {
  const lastKeyRef = useRef("");

  useEffect(() => {
    if (!enabled) return;
    const normalizedType = normalize(itemType);
    const normalizedId = normalize(itemId);
    const normalizedTitle = normalize(title);
    if (!normalizedType || !normalizedId || !normalizedTitle) return;
    const signature = `${normalizedType}:${normalizedId}:${normalizedTitle}:${normalize(secondaryText)}`;
    if (lastKeyRef.current === signature) return;
    lastKeyRef.current = signature;
    registerRecentView({
      itemType: normalizedType,
      itemId: normalizedId,
      title: normalizedTitle,
      secondaryText,
      route,
    });
  }, [enabled, itemId, itemType, route, secondaryText, title]);
}

